import { FC } from 'react';
import { reportUtilType } from '@/shared/utils/report/report-util-type';
// import { ReportMainTabState } from '@/entities/report/model/report.types';

interface ReportHeaderStntRightProps {
    nickname?: string;
    scoreType: string;
    score: number;
    submAt: FlagYn;
    selected: string;
    subTabChange: (val: string) => void;
    studentChange: (val: number) => void;
    // mainTab: ReportMainTabState;
    // isStudent?: boolean;
}

export const ReportHeaderStntRight: FC<ReportHeaderStntRightProps> = ({
    nickname,
    scoreType,
    score,
    submAt,
    selected,
    subTabChange,
    studentChange,
    // mainTab,
    // isStudent,
}) => {
    const stntsClick = (index: number) => {
        subTabChange('student');
        studentChange(index);
    };

    // 학생별 리포트는 index 1로 설정
    const stntIdx = 1;

    const leftBtnOn = selected === 'contents' ? 'on' : '';
    const rightBtnOn = selected === 'student' ? 'on' : '';

    return (
        <div className="box-right double">
            <div className="resultList" style={{ width: '100%' }}>
                <ul>
                    <li className={leftBtnOn}>
                        <button type="button" onClick={() => subTabChange('contents')}>
                            콘텐츠 정보
                        </button>
                    </li>
                    <li className={rightBtnOn}>
                        <button type="button" onClick={() => stntsClick(stntIdx)}>
                            {nickname ? `${nickname}` : '내 답안'}
                        </button>
                    </li>
                </ul>
                <ul>
                    <li className={leftBtnOn}>
                        점수 {reportUtilType.statusType(scoreType).criteria}
                    </li>
                    <li className={rightBtnOn}>
                        {submAt === 'Y' ? `${score}점 (${scoreType})` : '미제출'}
                    </li>
                </ul>
            </div>
        </div>
    );
};
